import React, { FC } from 'react';
import { t } from '@lingui/macro';

import { Notification } from '@rover/icons';
import { Box } from '@rover/kibble/core';
import { StringSystemType } from '@rover/kibble/core/styledSystemPropTypes';
import { useTheme } from '@rover/kibble/themes';

import { NOTIFICATIONS_CENTER_DROPDOWN_ID } from './constants';
import NotificationsCenterCounter from './NotificationsCenterCounter';

type Props = {
  unreadCountDisplay?: string;
  handleButtonClick: React.MouseEventHandler<HTMLButtonElement>;
  isOpen: boolean;
  buttonRef: React.MutableRefObject<HTMLButtonElement | null>;
  implementDjangoHacks: boolean;
  display?: StringSystemType;
};

const NotificationsCenterToggle: FC<Props> = ({
  unreadCountDisplay,
  handleButtonClick,
  isOpen,
  buttonRef,
  implementDjangoHacks,
  display = ['none', 'none', 'inline-block'],
}) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="notifications-center-toggle"
      as="button"
      role="button"
      ref={buttonRef}
      onClick={handleButtonClick}
      aria-expanded={isOpen}
      aria-label={
        unreadCountDisplay
          ? t`Notifications Center, ${unreadCountDisplay} unread notifications`
          : t`Notifications Center, 0 unread notifications`
      }
      aria-controls={NOTIFICATIONS_CENTER_DROPDOWN_ID}
      position="relative"
      alignItems="center"
      padding={implementDjangoHacks ? ['1x', '0x'] : ['1x', '1x', '0x']}
      background="navigation"
      border="none"
      borderRadius="primary"
      marginRight={implementDjangoHacks ? '2x' : undefined}
      marginLeft={implementDjangoHacks ? '1x' : undefined}
      display={display}
      sx={{
        cursor: 'pointer',
      }}
    >
      <>
        <Box
          width="16px"
          height="16px"
          sx={{
            color: theme.textColor.navigation.toString(),
            ':hover > & ': { color: theme.textColor.navigation_hover.toString() },
          }}
        >
          <Notification height="100%" width="auto" fill="currentColor" />
        </Box>
        {unreadCountDisplay && (
          <NotificationsCenterCounter
            unreadCountDisplay={unreadCountDisplay}
            implementDjangoHacks={implementDjangoHacks}
          />
        )}
      </>
    </Box>
  );
};

export default NotificationsCenterToggle;
